<template>
  <v-toolbar
    :clipped-left="$vuetify.breakpoint.lgAndUp"
    color="blue darken-1"
    dense
    dark
    app
    fixed
  >
    <v-toolbar-title class="">
      <v-toolbar-side-icon
        class="ma-0"
        @click.stop="$emit('toggle-sidebar-mini')"
      />
      <span class="hidden-sm-and-down">巧巧郎後臺管理 (TSMD)</span>
    </v-toolbar-title>

    <v-spacer/>
    <!-- <v-spacer/>

    <v-text-field
      flat
      clearable
      solo-inverted
      hide-details
      single-line
      label="Search"
      prepend-icon="search"
      class="hidden-sm-and-down"
    />

    <v-btn icon>
      <v-icon>notifications</v-icon>
    </v-btn> -->

    <v-toolbar-items>
      <v-btn
        flat
      ><v-icon
        left
        class="mr-2">face</v-icon> {{ name }}</v-btn>
      <v-btn
        flat
        @click="logout"
      >Logout</v-btn>
    </v-toolbar-items>
  </v-toolbar>
</template>

<script>
export default {
  name: 'ContHeader',
  components: {
  },
  computed: {
    name () {
      return this.$store.state.user.nickname
        ? this.$store.state.user.nickname
        : (this.$store.state.user.realname
          ? this.$store.state.user.realname
          : this.$store.state.user.username)
    }
  },
  methods: {
    logout () {
      if (confirm('請確認登出！')) {
        this.$store.dispatch('user/logout')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/_layout/ContHeader.vue